// components/common/NumberField.js
import React from 'react';
import { div } from 'react-bootstrap';
import rightarrowicon from '../../assets/images/icons/arrow-up.svg'
import leftarrowicon from '../../assets/images/icons/arrow-down.svg'
import leaficon from '../../assets/images/icons/leaf.svg'
const NumberField = ({
  name,
  value,
  onChange,
  placeholder,
  className,
  min = 1,    // Default minimum value set to 1
//   max = 12,    // Default maximum value set to 12
  step = 1
}) => {
  const handleChange = (e) => {
    // Convert the string value to a number or null if empty
    const numValue = e.target.value === '' ? null : Number(e.target.value);
    onChange({ value: numValue });
  };

  const increment = () => {
    const currentValue = value || min; // Default to min if null/undefined
    const newValue = Math.min(currentValue + step, );
    onChange({ value: newValue });
  };

  const decrement = () => {
    const currentValue = value || min; // Default to min if null/undefined
    const newValue = Math.max(currentValue - step, min);
    onChange({ value: newValue });
  };

  return (
    <div className={`number-field-container ${className || ''}`} style={{ display: 'flex' }}>
      <img
        src={leaficon}
        alt="icon"
        width={28}
            height={20}
      />

      <div className="inputfield">
        <div
          variant="outline-secondary"
          onClick={decrement}
          style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          className='decrement'
        >
          <img
            src={leftarrowicon}
            alt="icon"
            width={18}
            height={10}

          />
        </div>
        <div
          variant="outline-secondary"
          onClick={increment}
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
          className='increment'
        >
          <img
            src={rightarrowicon}
            alt="icon"
            width={18}
            height={10}

          />
        </div>
        <input
          type="number"
          name={name}
          value={value !== null && value !== undefined ? value : ''}
          onChange={handleChange}
          className="form-input"
          placeholder={placeholder}
          min={min}
        //   max={max}
          step={step}
          style={{
            textAlign: 'center',

            border: 'none',
            borderRadius: 0,
            padding: 0,
            height: "100%",
            cursor : "pointer",
          }}
          
        />
      </div>

    </div>
  );
};

export default NumberField;